<template>
  <div
    :class="[
      $style.notificationItemConfirmEmail,
      { [$style.notificationHeader]: !isNotificationPage },
    ]"
  >
    <ItemWrapper
      :notification="notification"
      variant="with-button"
      :is-notification-page="isNotificationPage"
      :class="$style.notificationItemEmailWrapper"
    >
      <template #icon>
        <img v-if="notification.data.icon" :src="notification.data.icon.url" />
      </template>
      <template #rightSide>
        <div :class="$style.emailNotifButtons">
          <BitButton
            v-if="isWaiting"
            type="secondary"
            is-fluid-width
            no-margin
            :disabled="isWaiting"
          >
            {{ resendButton }} ({{ counter }})
          </BitButton>
          <BitButton v-else type="secondary" no-margin is-fluid-width @click="confirmEmail">
            {{ buttonTitle }}
          </BitButton>
        </div>
      </template>
    </ItemWrapper>
  </div>
</template>

<script lang="ts" setup>
import { BitButton } from '@bit/ui-kit';
import { computed, onBeforeMount, ref } from 'vue';
import { useStoreSsPlayer } from '~/stores/softswiss/player';
import { useStoreButtonTitles } from '~/stores/strapi/buttonTitles';
import { useStoreModalConfirm } from '~/stores/strapi/modals/confirm';
import ItemWrapper from '../itemWrapper/itemWrapper.vue';
import type { INotificationFeedElement } from '~/types/notifications';

defineProps({
  notification: {
    type: Object as PropType<INotificationFeedElement>,
    required: true,
  },
  isNotificationPage: {
    type: Boolean,
    default: false,
  },
});

const storeButtons = useStoreButtonTitles();
const storeSsPlayer = useStoreSsPlayer();
const storeModalConfirm = useStoreModalConfirm();

const wasSent = ref(false);

const buttonTitle = computed(() =>
  wasSent.value ? storeButtons.emailResend : storeButtons.emailSend
);

const isWaiting = computed(() => storeModalConfirm.isCounterInProcess);
const resendButton = computed(() => storeButtons.emailResend);
const counter = computed(() => storeModalConfirm.counter);

/**
 * Method that sends confirmation email
 */
const confirmEmail = () => {
  wasSent.value = true;

  if (storeSsPlayer.playerInfo.email) {
    storeSsPlayer.resendConfirmationEmail(storeSsPlayer.playerInfo.email);
  }

  storeModalConfirm.startTimer();
  storeModalConfirm.openPopup();
};

onBeforeMount(() => storeModalConfirm.loadConfirmModal());
</script>
<style lang="scss" module src="./itemEmailNotification.scss"></style>
